<template>
  <transition name="modal">
    <div class="modal-mask" v-bind:class="{'modal-mask-large': !!modalMaskLarge}">
      <div class="modal-center">
        <div class="modal-wrapper">
          <div class="modal-container" v-bind:class="{'modal-container-large': !!modalMaskLarge}">
            <div class="modal-header">
              <slot name="header">タイトル</slot>
              <div class="pull-right">
                <button type="button" @click="$emit('close')" class="close"><span>×</span></button>
              </div>
            </div>

            <div class="modal-body">
              <slot name="body">
                本文(変更するためには親からの呼び出し時に(slot name="body")を指定してください)
              </slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="btn modal-default-button" @click="$emit('close')">
                  Close
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  created () {
    scrollTo(0, 0)
    document.addEventListener('keydown', this.closeModal)
  },
  props: ['modalMaskLarge'],
  methods: {
    closeModal: function (e) {
      if (e.keyCode === 27) {
        this.$emit('close')
      }
    }
  },
  destroyed: function () {
    document.removeEventListener('keydown', this.closeModal)
  },
  deactivated: function () {
    document.removeEventListener('keydown', this.closeModal)
  }
}
</script>



// WEBPACK FOOTER //
// Modal.vue?2d517187